// import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate, useLocation, Outlet, useParams} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
// import TopBarProgress from 'react-topbar-progress-indicator'
// import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
// import {WithChildren} from '../../_metronic/helpers'
import {IssueAreasPage} from '../pages/admin/IssueAreas/IssueAreasPage'
import {FTAImpactProvider} from '../contexts/fta-impact/FTAImpactContext'
import {AbilityContext} from '../modules/auth/core/AbilityContext'
import {useAbility} from '@casl/react'

import DashboardPage from '../pages/admin/dashboard/DashboardPage'
import HomePage from '../pages/national/home/HomePage'
import FTAImpactPage from '../pages/national/fta-impact/FTAImpactPage'
import InputOutputPage from '../pages/national/input-output-analyis/InputOutputPage'
import CGEPage from '../pages/national/cge/CGEPage'
import PreferenceLossPage from '../pages/national/preference-loss/PreferenceLossPage'
import TradePotentialCommodityPage from '../pages/national/trade-potential-commodity/TradePotentialCommodityPage'
import TradePotentialPage from '../pages/national/trade-potential/TradePotentialPage'
import TradeDataManagementPage from '../pages/admin/trade-data-management/TradeDataManagementPage'
import TradeDataManagementDetailPage from '../pages/admin/trade-data-management-detail/TradeDataManagementDetailPage'
import AgreementPage from '../pages/admin/trade-data-agreement/TradeDataAgreementPage'
import AgreementDetailPage from '../pages/admin/trade-data-agreement-detail/TradeDataAgreementDetailPage'
import AgreementChapterPage from '../pages/admin/trade-data-agreement-chapter/TradeDataAgreementChapterPage'
import AgreementChapterReorderPage from '../pages/admin/trade-data-agreement-chapter/AgreementChapterReorderPage'
import AgreementChapterReviewPage from '../pages/admin/trade-data-agreement-chapter-review/TradeDataAgreementChapterReviewPage'
import TariffPage from '../pages/admin/tariff/TariffPage'
import TariffDetailPage from '../pages/admin/tariff-detail/TariffDetailPage'
import MasterDataHSCategoryPage from '../pages/admin/master-data-hs-category/MasterDataHSCategoryPage'
import MasterDataHSCategoryDetailPage from '../pages/admin/master-data-hs-category-detail/MasterDataHSCategoryDetailPage'
import ManageUserRolePage from '../pages/admin/manage-user-role/ManageUserRolePage'
import ManageAvailableRolesPage from '../pages/admin/manage-available-roles/ManageAvailableRolesPage'
import ManageAvailableRolesDetailPage from '../pages/admin/manage-available-roles/ManageAvailableRolesDetailPage'
import ManageUserRoleDetailPage from '../pages/admin/manage-user-role/ManageUserRoleDetailPage'
import NoPermissionCard from '../../_metronic/layout/components/permission/NoPermissionCard'
import TradeDataAgreementNewPage from '../pages/admin/trade-data-agreement-new/TradeDataAgreementNewPage'
import TradeDataAgreementDetailNewPage from '../pages/admin/trade-data-agreement-detail-new/TradeDataAgreementDetailNewPage'
import TradeDataAgreementChapterNewPage from '../pages/admin/trade-data-agreement-chapter-new/TradeDataAgreementChapterNewPage'
import TradeDataAgreementChapterReviewNewPage from '../pages/admin/trade-data-agreement-chapter-review-new/TradeDataAgreementChapterReviewNewPage'
import TradeDataAgreementReviewPage from '../pages/admin/trade-data-agreement-review/TradeDataAgreementReviewPage'
import LegalTinaPage from '../pages/admin/legal-tina/LegalTinaPage'
import LegalTinaDetailPage from '../pages/admin/legal-tina-detail/LegalTinaDetailPage'
import LegalTinaReviewPage from '../pages/admin/legal-tina-review/LegalTinaReviewPage'
import MasterDataHSDescriptionPage from '../pages/admin/master-data-hs-description/MasterDataHSDescriptionPage'
import MasterDataHSDescriptionDetailPage from '../pages/admin/master-data-hs-description-detail/MasterDataHSDescriptionDetailPage'
import MasterDataHSDescriptionReviewPage from '../pages/admin/master-data-hs-description-review/MasterDataHSDescriptionReviewPage'
import FileUploadQueuePage from '../pages/admin/file-upload-queue/FileUploadQueuePage'
import GroupingsPage from '../pages/admin/groupings/GroupingsPage'
import GroupingsDetailPage from '../pages/admin/groupings-detail/GroupingsDetailPage'
import EconomyGroupsPage from '../pages/admin/economy-groups/EconomyGroupsPage'
import EconomyGroupsDetailPage from '../pages/admin/economy-groups/EconomyGroupsDetailPage'
import EconomiesPage from '../pages/admin/economies/EconomiesPage'
import EconomiesDetailPage from '../pages/admin/economies/EconomiesDetailPage'
import ActivityLogsPage from '../pages/admin/activity-logs/ActivityLogsPage'
import ResourcesPage from '../pages/admin/resources/ResourcesPage'
import ResourcesDetailPage from '../pages/admin/resources-detail/ResourcesDetailPage'
import TradeProvisionsPage from '../pages/admin/trade-provisions/TradeProvisionsPage'
import TradeProvisionsDetailPage from '../pages/admin/trade-provisions-detail/TradeProvisionsDetailPage'
import OecdDescriptionsPage from '../pages/admin/oecd-descriptions/OecdDescriptionsPage'
import OecdDescriptionsDetailPage from '../pages/admin/oecd-descriptions-detail/OecdDescriptionsDetailPage'
import CoefIoLmPage from '../pages/admin/coef-io-lm/CoefIoLmPage'
import CoefIoLmDetailPage from '../pages/admin/coef-io-lm-detail/CoefIoLmDetailPage'
import TariffReviewPage from '../pages/admin/tariff-review/TariffReviewPage'
import TradeDataManagementV2Page from '../pages/admin/trade-data-management-v2/TradeDataManagementV2Page'

// export const ROLES = {
//   superadmin: 1,
//   tina_admin: 2,
//   cambodia_member: 3,
//   tina_member: 4,
//   bangladesh_member: 5,
//   aptiad_admin: 6,
// }

const PrivateRoutes = () => {
  const ability = useAbility(AbilityContext)
  // NOTE: Route subject must be same as dss_menus.title to ensure the permission running properly

  const homeElement = ability.can('read', 'menuForUserHasEconomy') ? (
    <HomePage />
  ) : (
    <DashboardPage />
  )

  return (
    <FTAImpactProvider>
      <Routes>
        <Route element={<MasterLayout />}>
          {/* Redirect to Dashboard after success login/registartion */}
          <Route path='login/*' element={<Navigate to='/home' />} />
          <Route path='/' element={<Navigate to='/home' />} />
          <Route path='home' element={homeElement} />
          <Route path='third-party-impacts' element={<FTAImpactPage />} />
          <Route path='trade-prospect' element={<TradePotentialPage />} />
          <Route path='trade-prospect-commodity' element={<TradePotentialCommodityPage />} />
          <Route
            path='trade-prospect-commodity/:hs_code'
            element={<TradePotentialCommodityPage />}
          />
          <Route path='input-output-analysis' element={<InputOutputPage />} />
          <Route path='cge' element={<CGEPage />} />
          <Route
            path='preference-loss'
            element={
              <PermissionWrapper subject='menuForUserHasEconomy'>
                <PreferenceLossPage />
              </PermissionWrapper>
            }
          />

          {/* Admin Page */}
          <Route
            path='issue-areas-content-management'
            element={
              // <PermissionWrapper subject='MENU.ISSUE_AREAS'>
              <IssueAreasPage subject='MENU.ISSUE_AREAS' />
              // </PermissionWrapper>
            }
          />
          {/* Trade Data */}
          <Route
            path='trade-data'
            element={
              <PermissionWrapper subject='MENU.TRADE_DATA'>
                <TradeDataManagementPage subject='MENU.TRADE_DATA' />
              </PermissionWrapper>
            }
          />
          {/* Trade Data V2 – Country Overview */}
          <Route
            path='trade-data-v2'
            element={
              <PermissionWrapper subject={['MENU.TRADE_DATA_V2', 'MENU.TRADE_DATA']}>
                <TradeDataManagementV2Page subject='MENU.TRADE_DATA_V2' />
              </PermissionWrapper>
            }
          />
          <Route
            path='trade-data/:countrycode'
            element={
              <PermissionWrapper subject='MENU.TRADE_DATA'>
                <TradeDataManagementDetailPage />
              </PermissionWrapper>
            }
          />
          {/* Agreement */}
          <Route
            path='agreement'
            element={
              <PermissionWrapper subject='MENU.RTA'>
                <AgreementPage />
              </PermissionWrapper>
            }
          />
          <Route
            path='agreement/add'
            element={
              <PermissionWrapper subject='MENU.RTA'>
                <AgreementDetailPage subject='MENU.RTA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='agreement/:idAgreement'
            element={
              <PermissionWrapper subject='MENU.RTA'>
                <AgreementDetailPage subject='MENU.RTA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='agreement/:idAgreement/chapter/add'
            element={
              <PermissionWrapper subject='MENU.RTA'>
                <AgreementChapterPage subject='MENU.RTA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='agreement/:idAgreement/chapter/edit-order'
            element={
              <PermissionWrapper subject='MENU.RTA'>
                <AgreementChapterReorderPage subject='MENU.RTA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='agreement/review-chapter/:idReview'
            element={
              <PermissionWrapper subject='PERM_APPROVE_AGREEMENT'>
                <AgreementChapterReviewPage />
              </PermissionWrapper>
            }
          />
          <Route
            path='agreement/chapter/:idChapter/edit'
            element={
              <PermissionWrapper subject='MENU.RTA'>
                <AgreementChapterPage subject='MENU.RTA' />
              </PermissionWrapper>
            }
          />
          {/* RTA new */}
          <Route
            path='new-rta'
            element={
              <PermissionWrapper subject='MENU.NEW_RTA'>
                <TradeDataAgreementNewPage subject='MENU.NEW_RTA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='new-rta/add'
            element={
              <PermissionWrapper subject='MENU.NEW_RTA'>
                <TradeDataAgreementDetailNewPage subject='MENU.NEW_RTA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='new-rta/:idAgreement'
            element={
              <PermissionWrapper subject='MENU.NEW_RTA'>
                <TradeDataAgreementDetailNewPage subject='MENU.NEW_RTA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='new-rta/:idAgreement/chapter/add'
            element={
              <PermissionWrapper subject='MENU.NEW_RTA'>
                <TradeDataAgreementChapterNewPage subject='MENU.NEW_RTA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='new-rta/review-chapter/:idReview'
            element={
              <PermissionWrapper subject='PERM_APPROVE_AGREEMENT'>
                <TradeDataAgreementChapterReviewNewPage />
              </PermissionWrapper>
            }
          />
          <Route
            path='new-rta/review-agreement/:idAgreement'
            element={
              <PermissionWrapper subject='PERM_APPROVE_AGREEMENT'>
                <TradeDataAgreementReviewPage />
              </PermissionWrapper>
            }
          />
          <Route
            path='new-rta/chapter/:idChapter/edit'
            element={
              <PermissionWrapper subject='MENU.RTA'>
                <TradeDataAgreementChapterNewPage subject='MENU.RTA' />
              </PermissionWrapper>
            }
          />

          {/* File Upload Queue */}
          <Route
            path='file-upload-queue'
            element={
              <PermissionWrapper
                subject={[
                  'MENU.TARIFF',
                  'MENU.PREF_TARIFF',
                  'MENU.BOUND_TARIFF',
                  'MENU.MFN_TARIFF',
                ]}
              >
                <FileUploadQueuePage />
              </PermissionWrapper>
            }
          />

          {/* Tariff */}
          <Route
            path='legal-tina'
            element={
              <PermissionWrapper subject='MENU.LEGAL_TINA'>
                <LegalTinaPage subject='MENU.LEGAL_TINA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='legal-tina/add'
            element={
              <PermissionWrapper subject='MENU.LEGAL_TINA'>
                <LegalTinaDetailPage subject='MENU.LEGAL_TINA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='legal-tina/:uniqueCode'
            element={
              <PermissionWrapper subject='MENU.LEGAL_TINA'>
                <LegalTinaDetailPage subject='MENU.LEGAL_TINA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='legal-tina/:uniqueCode/edit'
            element={
              <PermissionWrapper subject='MENU.LEGAL_TINA'>
                <LegalTinaDetailPage subject='MENU.LEGAL_TINA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='legal-tina/review/:uniqueCode'
            element={
              <PermissionWrapper subject='PERM_APPROVE_LEGAL_TINA'>
                <LegalTinaReviewPage />
              </PermissionWrapper>
            }
          />

          {/* Economy Groups */}
          <Route
            path='economy-groups'
            element={
              <PermissionWrapper subject='MENU.ECONOMY_GROUPS'>
                <EconomyGroupsPage subject='MENU.ECONOMY_GROUPS' />
              </PermissionWrapper>
            }
          />
          <Route
            path='economy-groups/add'
            element={
              <PermissionWrapper subject='MENU.ECONOMY_GROUPS'>
                <EconomyGroupsDetailPage subject='MENU.ECONOMY_GROUPS' />
              </PermissionWrapper>
            }
          />
          <Route
            path='economy-groups/:id'
            element={
              <PermissionWrapper subject='MENU.ECONOMY_GROUPS'>
                <EconomyGroupsDetailPage subject='MENU.ECONOMY_GROUPS' />
              </PermissionWrapper>
            }
          />
          <Route
            path='economy-groups/:id/edit'
            element={
              <PermissionWrapper subject='MENU.ECONOMY_GROUPS'>
                <EconomyGroupsDetailPage subject='MENU.ECONOMY_GROUPS' />
              </PermissionWrapper>
            }
          />

          {/* Economies */}
          <Route
            path='economies'
            element={
              <PermissionWrapper subject='MENU.ECONOMIES'>
                <EconomiesPage subject='MENU.ECONOMIES' />
              </PermissionWrapper>
            }
          />
          <Route
            path='economies/add'
            element={
              <PermissionWrapper subject='MENU.ECONOMIES'>
                <EconomiesDetailPage subject='MENU.ECONOMIES' />
              </PermissionWrapper>
            }
          />
          <Route
            path='economies/:iso3'
            element={
              <PermissionWrapper subject='MENU.ECONOMIES'>
                <EconomiesDetailPage subject='MENU.ECONOMIES' />
              </PermissionWrapper>
            }
          />
          <Route
            path='economies/:iso3/edit'
            element={
              <PermissionWrapper subject='MENU.ECONOMIES'>
                <EconomiesDetailPage subject='MENU.ECONOMIES' />
              </PermissionWrapper>
            }
          />

          {/* Activity Logs */}
          <Route
            path='activity-logs'
            element={
              <PermissionWrapper subject='MENU.ACTIVITY_LOG'>
                <ActivityLogsPage />
              </PermissionWrapper>
            }
          />

          {/* Tariff */}
          <Route
            path='tariff/:typeTariff'
            element={
              <PermissionWrapper
                subject={[
                  'MENU.TARIFF',
                  'MENU.PREF_TARIFF',
                  'MENU.BOUND_TARIFF',
                  'MENU.MFN_TARIFF',
                ]}
              >
                <TariffPage subject='MENU.TARIFF' />
              </PermissionWrapper>
            }
          />
          <Route
            path='tariff/:typeTariff/add'
            element={
              <PermissionWrapper
                subject={[
                  'MENU.TARIFF',
                  'MENU.PREF_TARIFF',
                  'MENU.BOUND_TARIFF',
                  'MENU.MFN_TARIFF',
                ]}
              >
                <TariffDetailPage subject='MENU.TARIFF' />
              </PermissionWrapper>
            }
          />
          <Route
            path='tariff/:typeTariff/:idTariff'
            element={
              <PermissionWrapper
                subject={[
                  'MENU.TARIFF',
                  'MENU.PREF_TARIFF',
                  'MENU.BOUND_TARIFF',
                  'MENU.MFN_TARIFF',
                ]}
              >
                <TariffDetailPage subject='MENU.TARIFF' />
              </PermissionWrapper>
            }
          />
          {/* <Route
            path='tariff/:typeTariff/review-tariff'
            element={
              // <PermissionWrapper subject='PERM_APPROVE_TARIFF'>
              <TariffReviewPage />
              // </PermissionWrapper>
            }
          /> */}
          {/* Master Data HS Category */}
          <Route
            path='master-data-hs-categories/'
            element={
              <PermissionWrapper subject='MENU.MD.HS_CATEGORIES'>
                <MasterDataHSCategoryPage subject='MENU.MD.HS_CATEGORIES' />
              </PermissionWrapper>
            }
          />
          <Route
            path='master-data-hs-categories/add'
            element={
              <PermissionWrapper subject='MENU.MD.HS_CATEGORIES'>
                <MasterDataHSCategoryDetailPage subject='MENU.MD.HS_CATEGORIES' />
              </PermissionWrapper>
            }
          />
          <Route
            path='master-data-hs-categories/:idHS'
            element={
              <PermissionWrapper subject='MENU.MD.HS_CATEGORIES'>
                <MasterDataHSCategoryDetailPage subject='MENU.MD.HS_CATEGORIES' />
              </PermissionWrapper>
            }
          />

          {/* Groupings */}
          <Route
            path='groupings'
            element={
              <PermissionWrapper subject='MENU.MD.GROUPINGS'>
                <GroupingsPage subject='MENU.MD.GROUPINGS' />
              </PermissionWrapper>
            }
          />
          <Route
            path='groupings/add'
            element={
              <PermissionWrapper subject='MENU.MD.GROUPINGS'>
                <GroupingsDetailPage subject='MENU.MD.GROUPINGS' />
              </PermissionWrapper>
            }
          />
          <Route
            path='groupings/:idGrouping'
            element={
              <PermissionWrapper subject='MENU.MD.GROUPINGS'>
                <GroupingsDetailPage subject='MENU.MD.GROUPINGS' />
              </PermissionWrapper>
            }
          />

          {/* Resources */}
          <Route
            path='resources'
            element={
              <PermissionWrapper subject='MENU.MD.RESOURCES'>
                <ResourcesPage subject='MENU.MD.RESOURCES' />
              </PermissionWrapper>
            }
          />
          <Route
            path='resources/add'
            element={
              <PermissionWrapper subject='MENU.MD.RESOURCES'>
                <ResourcesDetailPage subject='MENU.MD.RESOURCES' />
              </PermissionWrapper>
            }
          />
          <Route
            path='resources/:idResource'
            element={
              <PermissionWrapper subject='MENU.MD.RESOURCES'>
                <ResourcesDetailPage subject='MENU.MD.RESOURCES' />
              </PermissionWrapper>
            }
          />

          {/* Trade Provisions */}
          <Route
            path='trade-provisions'
            element={
              <PermissionWrapper subject='MENU.MD.TRADE_PROVISIONS'>
                <TradeProvisionsPage subject='MENU.MD.TRADE_PROVISIONS' />
              </PermissionWrapper>
            }
          />
          <Route
            path='trade-provisions/add'
            element={
              <PermissionWrapper subject='MENU.MD.TRADE_PROVISIONS'>
                <TradeProvisionsDetailPage subject='MENU.MD.TRADE_PROVISIONS' />
              </PermissionWrapper>
            }
          />
          <Route
            path='trade-provisions/:idTradeProvision'
            element={
              <PermissionWrapper subject='MENU.MD.TRADE_PROVISIONS'>
                <TradeProvisionsDetailPage subject='MENU.MD.TRADE_PROVISIONS' />
              </PermissionWrapper>
            }
          />

          {/* OECD Descriptions */}
          <Route
            path='oecd-descriptions'
            element={
              <PermissionWrapper subject='MENU.MD.OECD_DESCRIPTIONS'>
                <OecdDescriptionsPage subject='MENU.MD.OECD_DESCRIPTIONS' />
              </PermissionWrapper>
            }
          />
          <Route
            path='oecd-descriptions/add'
            element={
              <PermissionWrapper subject='MENU.MD.OECD_DESCRIPTIONS'>
                <OecdDescriptionsDetailPage subject='MENU.MD.OECD_DESCRIPTIONS' />
              </PermissionWrapper>
            }
          />
          <Route
            path='oecd-descriptions/:idOecdDescription'
            element={
              <PermissionWrapper subject='MENU.MD.OECD_DESCRIPTIONS'>
                <OecdDescriptionsDetailPage subject='MENU.MD.OECD_DESCRIPTIONS' />
              </PermissionWrapper>
            }
          />

          {/* Coef IO LM */}
          <Route
            path='coef-io-lm'
            element={
              <PermissionWrapper subject='MENU.MD.COEF_IO_LM'>
                <CoefIoLmPage subject='MENU.MD.COEF_IO_LM' />
              </PermissionWrapper>
            }
          />
          <Route
            path='coef-io-lm/add'
            element={
              <PermissionWrapper subject='MENU.MD.COEF_IO_LM'>
                <CoefIoLmDetailPage subject='MENU.MD.COEF_IO_LM' />
              </PermissionWrapper>
            }
          />
          <Route
            path='coef-io-lm/:idCoefIoLm'
            element={
              <PermissionWrapper subject='MENU.MD.COEF_IO_LM'>
                <CoefIoLmDetailPage subject='MENU.MD.COEF_IO_LM' />
              </PermissionWrapper>
            }
          />

          {/* Master Data HS Description */}
          <Route
            path='master-data-hs-descriptions/'
            element={
              <PermissionWrapper subject='MENU.MD.HS_DESCRIPTION'>
                <MasterDataHSDescriptionPage subject='MENU.MD.HS_DESCRIPTION' />
              </PermissionWrapper>
            }
          />
          <Route
            path='master-data-hs-descriptions/add'
            element={
              <PermissionWrapper subject='MENU.MD.HS_DESCRIPTION'>
                <MasterDataHSDescriptionDetailPage subject='MENU.MD.HS_DESCRIPTION' />
              </PermissionWrapper>
            }
          />
          <Route
            path='master-data-hs-descriptions/:idHS'
            element={
              <PermissionWrapper subject='MENU.MD.HS_DESCRIPTION'>
                <MasterDataHSDescriptionDetailPage subject='MENU.MD.HS_DESCRIPTION' />
              </PermissionWrapper>
            }
          />
          <Route
            path='master-data-hs-descriptions/review/:id'
            element={
              <PermissionWrapper subject='PERM_APPROVE_HS_DESCRIPTION'>
                <MasterDataHSDescriptionReviewPage />
              </PermissionWrapper>
            }
          />

          {/* Role Management */}
          <Route
            path='manage-roles'
            element={
              <PermissionWrapper subject='MENU.MANAGE_AVAILABLE_ROLES'>
                <ManageAvailableRolesPage subject='MENU.MANAGE_AVAILABLE_ROLES' />
              </PermissionWrapper>
            }
          />
          <Route
            path='manage-roles/add'
            element={
              <PermissionWrapper subject='MENU.MANAGE_AVAILABLE_ROLES'>
                <ManageAvailableRolesDetailPage subject='MENU.MANAGE_AVAILABLE_ROLES' />
              </PermissionWrapper>
            }
          />
          <Route
            path='manage-roles/:idRole'
            element={
              <PermissionWrapper subject='MENU.MANAGE_AVAILABLE_ROLES'>
                <ManageAvailableRolesDetailPage subject='MENU.MANAGE_AVAILABLE_ROLES' />
              </PermissionWrapper>
            }
          />

          <Route
            path='manage-user-role'
            element={
              <PermissionWrapper subject='MENU.MANAGE_USER_ROLE'>
                <ManageUserRolePage subject='MENU.MANAGE_USER_ROLE' />
              </PermissionWrapper>
            }
          />

          <Route
            path='manage-user-role/add'
            element={
              <PermissionWrapper subject='MENU.MANAGE_USER_ROLE'>
                <ManageUserRoleDetailPage subject='MENU.MANAGE_USER_ROLE' />
              </PermissionWrapper>
            }
          />

          <Route
            path='manage-user-role/:idAdmin'
            element={
              <PermissionWrapper subject='MENU.MANAGE_USER_ROLE'>
                <ManageUserRoleDetailPage subject='MENU.MANAGE_USER_ROLE' />
              </PermissionWrapper>
            }
          />
        </Route>
      </Routes>
    </FTAImpactProvider>
  )
}

// const SuspensedView: FC<WithChildren> = ({children}) => {
//   const baseColor = getCSSVariableValue('--bs-primary')
//   TopBarProgress.config({
//     barColors: {
//       '0': baseColor,
//     },
//     barThickness: 1,
//     shadowBlur: 5,
//   })
//   return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
// }

const PermissionWrapper: React.FC<{subject: string | string[]; children: any}> = ({
  subject,
  children,
}) => {
  const ability = useAbility(AbilityContext)

  const subjects = Array.isArray(subject) ? subject : [subject]
  const canAccess = subjects.some(
    (s) =>
      ability.can('read', s) ||
      ability.can('read', '/' + s) ||
      ability.can('read', s.replace(/^\//, '')) ||
      ability.can('read', s.split('?')[0]) ||
      ability.can('approve', s)
  )
  return canAccess ? children : <NoPermissionCard />
}

export {PrivateRoutes}
